import React, {useContext, useEffect, useState}from 'react';
import "../Styles/EditPatientCss.css";
import { submitEditPatientDetails, getPatientDetailsAPI } from "../../../../service/StudyListService";
import { useFormik } from "formik";
import {getEditPatientSchema} from "./EditPatientSchema";
import "../../../../index.css";
import Moment from "moment";
import { useTranslation } from "react-i18next";
import EditPatientBody from './EditPatientBody';
import userContext from '../../../../context/users/UserContext';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import ModalMain from '../../../../components/Modal/ModalMain';
import loaderContext from '../../../../context/loader/LoaderContext';
import studylistContext from '../../../../context/studylist/StudylistContext';
import ConfirmModal from '../../../../components/Modal/ConfirmModal';
import toastContext from '../../../../context/toast/ToastContext';
import { TOAST_TYPE } from '../../../../constants/Constants';
const EditPatientModal = (props) => {
  const {ref, setLoaderRunning} = useContext(loaderContext);
  const { setDataQueryState, dataQueryState} = useContext(studylistContext);
  const { showToastv2 } = useContext(toastContext);
    const [patientDetails, setPatientDetails] = useState({});
    const [loadingState, setLoadingState] = useState("");
    const [loading, setLoading] = useState(false);
    const [filterObj, setFilterObj] = useState({});
    const { username } = useContext(userContext);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingValues, setPendingValues] = useState(null);
    const [reportedModalityError, setReportedModalityError] = useState("");
    const [showReportedErrorModal, setShowReportedErrorModal] = useState(false);

    //const studyId = 66;
    const studyId = props.studyId;
    const [t] = useTranslation();

    function hideEditPatientModal() {
      props.setShowEditPatientModal(false);
    }

    
     const isQCStudy = props.data.row.original.reportDoneStatus !== null && props.data.row.original.reportDoneStatus !== undefined ? 
      (props.data.row.original.reportDoneStatus == 3 || props.data.row.original.reportDoneStatus == 4 || props.data.row.original.reportDoneStatus == 5 ):false 

    const formatDate = (date) => {
      var currentDate = Moment(date).local().format("DD-MMM-YYYY");
      return date == "" ? "" : currentDate;
    };


    // trim leading/trailing spaces AND collapse runs of internal whitespace to a single
    // space
    const cleanSpaces = (s) => (s == null ? s : s.replace(/\s+/g, " ").trim());

    const editPatientApiPayload = (values) =>{
      return ({
        id : studyId,
        patientName : cleanSpaces(values.patientName),
        patientId : cleanSpaces(values.patientId),
        patientAge : cleanSpaces(values.age),
        patientSex : filterObj.sex,
        patientBirthdate : filterObj.dob == null ? null : formatDate(filterObj.dob),
        modalityId: filterObj.modality,
        studyDescription : cleanSpaces(values.studyDescription),
        referringPhysician: cleanSpaces(values.referringPhysician) || null,
        studyEmergency : filterObj.studyEmergency,
      })
    }

    const handleRowUpdateForPatientDetails = (values, latestAiProcessed) => {

      let newIndex = -1;
      let newData = dataQueryState?.data?.rows.filter((row, index) => {
        if (row.id == props.studyId) {
          newIndex = index;
          return true;
        }
        return false;
      });

      setDataQueryState(() => {
        const newValue = {
          ...dataQueryState
        };
        console.log(props.data)
        if(props.data.row.getIsExpanded()) {
          props.data.row.toggleExpanded();
        }
        if(newValue.data.rows[newIndex].patientId != cleanSpaces(values.patientId)) {
          newValue.data.rows[newIndex].priorsCount = 0;
        }
        newValue.data.rows[newIndex].patientName = cleanSpaces(values.patientName);
        newValue.data.rows[newIndex].patientId = cleanSpaces(values.patientId);
        if(filterObj?.modalityName){
          newValue.data.rows[newIndex].modality.name = filterObj.modalityName;
        }
        newValue.data.rows[newIndex].patientAge = cleanSpaces(values.age);
        newValue.data.rows[newIndex].studyDescription = cleanSpaces(values.studyDescription);
        newValue.data.rows[newIndex].patientSex = filterObj.sex;
        newValue.data.rows[newIndex].edited = true;
        const xrayModalities = ['CR', 'DX', 'RG', 'SC'];
        const newModalityName = filterObj.modalityName;
        const oldModalityName = patientDetails?.modality?.name;
        if (newModalityName && oldModalityName) {
          const isNewXray = xrayModalities.includes(newModalityName.toUpperCase());
          const isOldXray = xrayModalities.includes(oldModalityName.toUpperCase());
          if (!isOldXray && isNewXray) {
            // non-xray → xray: study is being re-sent for triaging, always show In Progress
            //const resolvedAiProcessed = latestAiProcessed ?? 2;
            //newValue.data.rows[newIndex].aiProcessed = resolvedAiProcessed;
            //newValue.data.rows[newIndex].triageXRAYStudies = resolvedAiProcessed === 2;
            newValue.data.rows[newIndex].aiProcessed = 2;
            newValue.data.rows[newIndex].triageXRAYStudies = true;
            newValue.data.rows[newIndex].aiEmergencyMax = -1;
            newValue.data.rows[newIndex].studyPredictionList = [];
            newValue.data.rows[newIndex].studyClassificationPredictionList = [];
            newValue.data.rows[newIndex].vendorPredictionList = [];
          } else if (isOldXray && !isNewXray) {
            // xray → non-xray: clear all AI data
            newValue.data.rows[newIndex].studyPredictionList = [];
            newValue.data.rows[newIndex].studyClassificationPredictionList = [];
            newValue.data.rows[newIndex].vendorPredictionList = [];
            newValue.data.rows[newIndex].triageXRAYStudies = false;
            newValue.data.rows[newIndex].aiProcessed = 0;
            newValue.data.rows[newIndex].aiEmergencyMax = -1;
            newValue.data.rows[newIndex].attention = false;
          }
        }
        if(filterObj.studyEmergency === 3){
          newValue.data.rows[newIndex].emergency = true;
          newValue.data.rows[newIndex].nonMedicalEmergency = true;
        }else if(filterObj.studyEmergency === 2){
          newValue.data.rows[newIndex].emergency = true;
          newValue.data.rows[newIndex].nonMedicalEmergency = false;
        }else if(filterObj.studyEmergency === 1){
          newValue.data.rows[newIndex].emergency = false;
          newValue.data.rows[newIndex].nonMedicalEmergency = false;
        }
        return newValue;
      });
    }

    const submitEditPatient = async (values) => {

      setLoaderRunning(true);
      ref.current.continuousStart();
      setLoading(true);

      const editPatientDto = editPatientApiPayload(values);

      const response = await submitEditPatientDetails(editPatientDto, props.blitzSession);

      setLoading(false);

      if (response.status === 200 && response.data.result === "SUCCESS") {

        setLoaderRunning(false);
        ref.current.complete();

        if(props.blitzSession){
          props.handleCurrentStudyUpdate(values, filterObj);
        } else {
          //const latestDetails = await getPatientDetailsAPI(studyId);
          //const latestAiProcessed = latestDetails?.data?.data?.studyEditDto?.aiProcessed;
          handleRowUpdateForPatientDetails(values);
        }

        showToastv2(TOAST_TYPE.SUCCESS, "Patient information updated successfully");

        props.setShowEditPatientModal(false);
      }
    };
    const handleInfoOk = () => {
      setShowConfirmModal(false);
      submitEditPatient(pendingValues);
    };

    const {
      values,
      errors,
      handleChange,
      handleSubmit,
    } = useFormik({
      initialValues:  {
        patientName: patientDetails?.patientName,
        patientId: patientDetails.patientId,
        modality: patientDetails.modality,
        age: patientDetails.patientAge,
        sex: patientDetails.patientSex,
        dob: patientDetails.patientBirthdate,
        studyDescription: patientDetails.studyDescription,
        referringPhysician: patientDetails.referringPhysician,
        studyEmergency : patientDetails.studyEmergency
    },
      enableReinitialize: true,
      validationSchema: getEditPatientSchema(isQCStudy),
      // onSubmit: async (values, actions) => {
      //   console.log("I am here in submit");
      //   setLoadingState("Update patient details");

      //   const status = props.data.row.original.reportDoneStatus;
      //   const isQCFlow =
      //       status === 3 ||
      //       status === 4 ||
      //       status === 5;

      //   let revertChoice = false;

      //   if (!isQCFlow) {
      //       const confirmRevert = window.confirm(
      //         "Would you like to revert this study to Unreported?"
      //       );
      //       revertChoice = confirmRevert;
      //   }

      //   setLoaderRunning(true);
      //   ref.current.continuousStart();
      //   setLoading(true);
      //   const editPatientDto = editPatientApiPayload(values, revertChoice);
      //   const response = await submitEditPatientDetails(editPatientDto, props.blitzSession);
      //   setLoading(false);
      //   if (response.status === 200 && response.data.result === "SUCCESS") {
      //     setLoaderRunning(false);
      //     ref.current.complete();
      //     let eventProperties = {
      //       "STUDY ID": studyId,
      //     };
      //     if(props.blitzSession != null && props.blitzSession != undefined){
      //       props.handleCurrentStudyUpdate(values, filterObj);
      //     } else {
      //       handleRowUpdateForPatientDetails(values);
      //     }
      //     props.setShowEditPatientModal(false);          
      //   }
      //   else{
      //     setLoaderRunning(false);
      //     ref.current.complete();
      //     props.setShowEditPatientModal(false);  
      //   }
      // }
      onSubmit: async (values) => {

      const modalityChanged = filterObj.modality &&
        patientDetails.modality?.id &&
        filterObj.modality !== patientDetails.modality.id;

      if (modalityChanged) {
        const latestDetails = await getPatientDetailsAPI(studyId);
        const latestStatus = latestDetails?.data?.data?.studyEditDto?.reportDoneStatus;
        if (latestStatus === 2) {
          setShowReportedErrorModal(true);
          return;
        }
        if (latestStatus === 1 || latestStatus === 3 || latestStatus === 4 || latestStatus === 5) {
          setReportedModalityError("");
          setPendingValues(values);
          setShowConfirmModal(true);
          return;
        }
      }

      setReportedModalityError("");
      submitEditPatient(values);
    }
    });

    const handleKeyPress = (event) => {
      console.log("--- Enter is pressed ----");
      if (event.key === "Enter") {
        handleSubmit();
      }
    }

    let PrimaryButtonList = [
      {
          title:t("button.submit"),
          onclick: handleSubmit,
      }
    ];
    let DefaultButtonList = [
      {
          title:t("button.cancel"),
          onclick: hideEditPatientModal
      }
    ];

    const modalDetails = {
      header: <ModalHeader updatedModal={true} patientName={props.patientName} patientID={props.patientId} heading={t("patient.title")} handleCancel={hideEditPatientModal}/>,
      footer : <ModalFooter PrimaryButtonList={PrimaryButtonList} DefaultButtonList={DefaultButtonList} key={props.studyId}/>,
      body : <EditPatientBody handleEnterKeyPress={handleKeyPress} setPatientDetails={setPatientDetails} values={values} handleChange={handleChange} studyId={studyId} setShowEditPatientModal={props.setShowEditPatientModal} filterObj={filterObj} setFilterObj={setFilterObj} errors={errors} reportDoneStatus={props.data.row.original.reportDoneStatus} reportedModalityError={reportedModalityError}/>,
      width : "700px"
    }
    
    return (
      <div>
          <ModalMain updatedModal={true} showModal={props.showEditPatientModal} modalDetails={modalDetails}/>
          <ConfirmModal
            showConfirmModal={showConfirmModal}
            title="Info"
            message="The saved report may be affected by this modality change. Please review before submitting."
            confirmButtonText="OK"
            handleConfirm={handleInfoOk}
            handleCloseIcon={handleInfoOk}
          />
          <ConfirmModal
            showConfirmModal={showReportedErrorModal}
            title="Info"
            message="Patient information cannot be modified for a study that has already been reported."
            confirmButtonText="OK"
            handleConfirm={() => setShowReportedErrorModal(false)}
            handleCloseIcon={() => setShowReportedErrorModal(false)}
          />
      </div>
    );
  };

export default EditPatientModal